<script lang="ts">
  import Button from '$components/elements/Button.svelte';
  import Text from '$components/utils/Text.svelte';
</script>

<div class="hp-intro">
  <div class="hp-intro__text">
    <h1>
      <Text key="page.homepage.hp-intro.heading.1" />
    </h1>
    <h1>
      <Text key="page.homepage.hp-intro.heading.2" />
    </h1>
    <p>
      <Text key="page.homepage.hp-intro.text" />
    </p>
    <div class="hp-intro__text__button-container">
      <Button icon="arrow-right" iconColor="#fff" type="spacious" href="/online">
        <Text key="page.homepage.hp-intro.button.read" />
      </Button>
    </div>
  </div>
  <div class="hp-intro__image">
    <img src="/intro/bible--intro.webp" alt="Bible21" />
    <div class="hp-intro__image__button-container">
      <Button
        icon="shopping-cart"
        iconColor="#fff"
        color="#c99e77"
        iconSize={20}
        target="_blank"
        href="https://www.biblion.cz/kompletni-bible/?utm_source=bible21&utm_medium=homepage&utm_campaign=homepage_hero_button"
      >
        <Text key="page.homepage.hp-intro.button.buy" />
      </Button>
    </div>
  </div>
</div>

<style lang="scss">
  .hp-intro {
    font-size: 1vw;
    display: grid;
    grid-template-columns: 1fr auto;
    width: 1280px;
    max-width: 80em;
    margin: calc(4em + 89px) auto 83px;
    align-items: center;
    &__text {
      h1 {
        font-weight: 800;
        font-size: 3.9em;
        line-height: 130%;
      }
      p {
        font-weight: 500;
        font-size: 1.06em;
        line-height: 164%;
        max-width: 38em;
        margin: 1.4em 0 2.08em;
      }
    }
    &__image {
      position: relative;
      margin-right: 3em;
      img {
        width: 28.5em;
        filter: drop-shadow(10px 14px 34px rgba($color-black, 0.05))
          drop-shadow(30px 34px 124px rgba($color-black, 0.33));
      }
      &__button-container {
        top: 75%;
        left: 80%;
        position: absolute;
      }
    }
  }
  @include desktop-max {
    .hp-intro {
      font-size: 16px;
    }
  }
  @media screen and (max-width: 1120px) {
    .hp-intro {
      &__image {
        margin-right: 4em;
        &__button-container {
          left: 65%;
        }
      }
    }
  }
  @media screen and (max-width: 880px) {
    .hp-intro {
      &__image {
        &__button-container {
          left: 50%;
        }
      }
    }
  }
  @include mobile {
    .hp-intro {
      grid-template-columns: 1fr;
      max-width: 100vw;
      padding: 0 4.5vw 60vw;
      margin: calc(4em + 89px) 0 -50vw;
      overflow-x: hidden;
      position: relative;
      &__text {
        display: contents;
        z-index: 10;
        h1 {
          font-size: 7.7vw;
        }
        p {
          font-size: 4.4vw;
          padding-right: 2vw;
        }
        &__button-container {
          position: absolute;
          left: 4.4vw;
          top: 70vw;
          z-index: 10;
        }
      }
      &__image {
        display: contents;
        z-index: 1;
        img {
          width: 90vw;
          translate: 26vw 0;
          filter: none;
        }
        &__button-container {
          left: 4.4vw;
          top: calc(73vw + 48px);
        }
      }
    }
  }
</style>
